// Gusto39 Suche: Vorschläge beim Tippen (Section predictive-search), „Zuletzt gesucht“ (nur in diesem Browser).
// Ohne JavaScript bleibt die Suche ein normales GET-Formular.
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const suggestUrl = (q, types, limit) => `${root}search/suggest?${new URLSearchParams({
    q, section_id: 'predictive-search', 'resources[type]': types, 'resources[limit]': limit,
    'resources[options][fields]': 'title,product_type,tag,variants.sku,variants.title,vendor',
  })}`;
  const searchUrl = (q) => `${root}search?${new URLSearchParams({ q, type: 'product', 'options[prefix]': 'last' })}`;
  const load = async (url, signal) => new DOMParser().parseFromString(await (await fetch(url, { signal })).text(), 'text/html');

  // Vorschläge unter jedem Suchfeld (Kopf, 404, Suchseite)
  document.querySelectorAll('[data-search-box]').forEach((box) => {
    const input = box.querySelector('input[type="search"]');
    const out = box.querySelector('[data-suggest]');
    if (!input || !out) return;
    let timer;
    let ctrl;
    const close = () => {
      out.hidden = true;
      out.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    };
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) return close();
      ctrl?.abort();
      ctrl = new AbortController();
      out.setAttribute('aria-busy', 'true');
      try {
        const doc = await load(suggestUrl(q, 'query,product', 4)  /* Abnahme A17: keine Shop-Kollektionen/-Seiten (Altbestand) */, ctrl.signal);
        const res = doc.querySelector('[data-suggest-results]');
        if (!res || input.value.trim() !== q) return;
        out.replaceChildren(res);
        out.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') close();
      } finally {
        out.removeAttribute('aria-busy');
      }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 200); });
    input.addEventListener('focus', () => { if (out.hidden && input.value.trim().length >= 2) run(); });
    // Escape schließt erst die Vorschläge, nicht gleich das Suchfeld im Kopf.
    box.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || out.hidden) return;
      event.stopPropagation();
      close();
      input.focus();
    });
    document.addEventListener('click', (event) => { if (!box.contains(event.target)) close(); });
    box.addEventListener('focusout', (event) => { if (event.relatedTarget && !box.contains(event.relatedTarget)) close(); });
  });

  // Zuletzt gesucht: Begriff merken, auf der Suchseite ohne Begriff als Chips zeigen.
  const KEY = 'gusto39-recent-search';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* privat */ } };
  const params = new URLSearchParams(location.search);
  const term = (params.get('q') || '').trim();
  if (term && /\/search\/?$/.test(location.pathname)) {
    write([term, ...read().filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, 5));
  }
  const recent = document.querySelector('[data-search-recent]');
  if (recent) {
    const list = read();
    const ul = recent.querySelector('[data-search-recent-list]');
    list.forEach((t) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'pg-chip';
      a.href = searchUrl(t);
      a.textContent = t;
      li.append(a);
      ul.append(li);
    });
    recent.hidden = list.length === 0;
    recent.querySelector('[data-search-recent-clear]')?.addEventListener('click', () => {
      write([]);
      recent.hidden = true;
    });
  }
})();
